import { DATA_SOURCES } from '@/config/constants';
import RelatedBrandsSectionShell from './RelatedBrandsSectionShell';

/**
 * Renders the Related Brands table on a TikTok category surface. Backed by
 * `tiktok_data_store_category_related_brand`.
 */
function RelatedBrandsSectionTable(props) {
    return (
        <RelatedBrandsSectionShell {...props} source={DATA_SOURCES.TIKTOK} />
    );
}

export default RelatedBrandsSectionTable;
